import { useEffect } from 'react';
import { useIssueFields } from '../get-issue-fields';
import { useGroupBy } from '../group-by';

export const useClearStaleGroupBy = ({ onClear }: { onClear: () => void }) => {
	const [groupByFieldId, setGroupBy] = useGroupBy();

	const { getAvailableFields, loading } = useIssueFields();

	const availableFields = getAvailableFields();

	useEffect(() => {
		if (!groupByFieldId || loading) {
			return;
		}

		const isGroupedFieldAvailable = availableFields.some((field) => field.id === groupByFieldId);

		if (!isGroupedFieldAvailable) {
			setGroupBy(undefined);
			onClear();
		}
	}, [groupByFieldId, setGroupBy, availableFields, loading, onClear]);

	return null;
};
